import * as React from 'react';
import { ColumnsType } from "antd/es/table";
import { Table, Descriptions } from 'antd';
import * as AuthService from '../../Service/AuthService';
import { User } from 'tree-wallet-client';
import message from "antd/es/message";
import CopyOutlined from '@ant-design/icons/lib/icons/CopyOutlined';
import { CONTENT_COPIED, CONTENT_COPY_FAILED } from '../../Helper/BannerMessages';

interface DataType {
  level: string;
  timestamp: number;
  message: string;
}

const columns: ColumnsType<DataType> = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    render: (timestamp: number) => new Date(timestamp).toLocaleString(),
    sorter: (a: DataType, b: DataType) => a.timestamp - b.timestamp,
  },
  {
    title: 'Level',
    dataIndex: 'level',
  },
  {
    title: 'Error',
    dataIndex: 'message',
  },
];

export default function TestErrorLog() {
  const [errors, setErrors] = React.useState([]);
  const [user, setUser] = React.useState<User>();

  React.useEffect(() => {
    const localErrorsJson = localStorage.getItem('errors') || '[]';
    setErrors(JSON.parse(localErrorsJson));
    (async () => {
      const user = await AuthService.getUser();
      setUser(user);
    })();
  }, []);

  const onCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(errors));
      message.success(CONTENT_COPIED);
    } catch (err) {
      message.error(CONTENT_COPY_FAILED);
    }
  }

  return (
    <div style={{ padding: '20px', display: "block" }}>
      <div style={{ display: 'flex' }}>
        <h1>Errors Log</h1>
        <div style={{ lineHeight: '33px' }}>
          <CopyOutlined onClick={onCopyToClipboard} style={{ fontSize: 'x-large', verticalAlign: 'bottom', marginLeft: '5px' }} />
        </div>
      </div>
      {user &&
        <div style={{ padding: '10px 0 20px' }}>
          <Descriptions title="User Info" size="small">
            <Descriptions.Item label="ID">{user.id}</Descriptions.Item>
            <Descriptions.Item label="Email">{user.email}</Descriptions.Item>
            <Descriptions.Item label="First name">{user.firstName}</Descriptions.Item>
            <Descriptions.Item label="Last name">{user.lastName}</Descriptions.Item>
            <Descriptions.Item label="Roles">
              <div>{user.roles.map((role) => role)}</div>
            </Descriptions.Item>
          </Descriptions>
        </div>
      }
      <div>
        <div style={{ display: 'flex' }}>
          <h3>Errors</h3>
          <div>
            <CopyOutlined onClick={onCopyToClipboard} style={{ fontSize: 'large', verticalAlign: 'bottom', marginLeft: '5px' }} />
          </div>
        </div>
        <Table columns={columns} dataSource={errors}></Table>
      </div>
    </div>
  );
}